/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { CargoItemTypesDaoService } from '../cargo-item-types-dao.service';
import {
  DbPersistenceService,
  Query
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppConfig } from 'src/app/app.config';
import { CargoItemType} from 'src/app/_model/cargo-item-types';
import { CargoItemTypeDbTableDefinition } from './cargo-item-types-db-table-definition';

@Injectable()
export class CargoItemTypesDbDaoService implements CargoItemTypesDaoService {

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private cargoItemTypeTableDefinition: CargoItemTypeDbTableDefinition,
  ) { }

  public async saveCargoItemTypes(cargoItemTypes: CargoItemType[]): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb();

      var cargoItemTypeQueries: Query[] = [];
      for (const cargoItemType of cargoItemTypes) {
        let cargoItemTypeQuery: Query = {
          statement:
            'INSERT OR REPLACE INTO ' +
            this.cargoItemTypeTableDefinition.tableName +
            '(id, databag, label)' +
            ' VALUES (?,?,?)',
          parameters: [
            Number(cargoItemType.getImsId()),
            cargoItemType.databag ? JSON.stringify(cargoItemType.databag) : undefined,
            cargoItemType.label
          ]
        };
        cargoItemTypeQueries.push(cargoItemTypeQuery);
      }

      await this.dbPersistenceService.executeBatch(db, cargoItemTypeQueries);
    } catch (error) {
      this.logger.log(
        'Error saving CargoItemTypes to db',
        error,
        '-',
        error.message
      );
    }
  }
  public async getCargoItemTypes(): Promise<CargoItemType[]> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      let cargoItemTypes: CargoItemType[] = [];

      // Get Synced CargoItemtTypes
      let data = await this.dbPersistenceService.executeQuery(db, {
        statement: 'SELECT * FROM ' + this.cargoItemTypeTableDefinition.tableName + ';',
        parameters: null
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        cargoItemTypes.push(
          CargoItemType.fromDto({
            id: row['id'],
            label: row['label']
          }, row['databag'] ? JSON.parse(row['databag']): undefined)
        );
      }

      return cargoItemTypes;
    } catch (error) {
      this.logger.log('Error reading CargoItemType from db', error);
      return undefined
    }
  }

  public async reset() {
    // Do nothing
  }

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(this.constructor.name, "truncate table", this.cargoItemTypeTableDefinition.tableName)
    await this.dbPersistenceService.truncateTable(db, this.cargoItemTypeTableDefinition.tableName);
  }

}
